"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var Forms = _interopRequireWildcard(require("../components/Forms"));
var _uuid = _interopRequireDefault(require("uuid"));
var _components = require("../components");
var _helpers = require("../helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class EditFormFactory extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleAdd", (prop, name, id) => {
      const {
        state,
        onChange
      } = this.props;
      const newValue = {
        [prop]: [...(state[prop] ? state[prop] : []), {
          [name]: id
        }]
      };
      return new Promise(resolve => {
        onChange(newValue);
        resolve();
      });
    });
    _defineProperty(this, "handleDrop", (prop, name, id) => {
      const {
        state,
        onChange
      } = this.props;
      const newValue = {
        [prop]: state[prop].filter(value => value[name] !== id)
      };
      return new Promise(resolve => {
        onChange(newValue);
        resolve();
      });
    });
    _defineProperty(this, "renderFormGrid", fields => {
      if (fields.rows) return /*#__PURE__*/_react.default.createElement("div", {
        className: fields.size || 'col'
      }, fields.rows.map((field, index) => /*#__PURE__*/_react.default.createElement("div", {
        className: "row",
        key: `row-${index}`
      }, this.renderFormGrid(field))));
      if (fields.fields) return /*#__PURE__*/_react.default.createElement("div", {
        className: fields.size || 'col'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row",
        key: ''
      }, fields.fields.map(field => this.renderFormGrid(field))));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: fields.size || 'col'
      }, this.renderFormField(fields));
    });
    _defineProperty(this, "renderFormField", field => {
      const {
        schema,
        state,
        onChange
      } = this.props;
      const Component = schema[field.key].component || Forms[schema[field.key].type];
      if (!Component) return console.warn(`No component for field ${field.key}`);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `form-group`,
        key: field.key
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: field.key,
        className: 'text-muted text-uppercase'
      }, schema[field.key].type !== "Bool" && /*#__PURE__*/_react.default.createElement("small", null, schema[field.key].displayName)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Component, {
        key: field.key
        // value={fs.type === 'Join' ? store.data[field.id] : state[field.id]}
        ,
        value: state[field.key],
        onChange: value => onChange({
          [field.key]: value
        }),
        onAdd: this.handleAdd,
        onDrop: this.handleDrop,
        name: field.key,
        schema: schema[field.key],
        row: state,
        editForm: true
      }))));
    });
  }
  render() {
    const {
      fields,
      onSubmit,
      fetching,
      state
    } = this.props;
    if (!state) return /*#__PURE__*/_react.default.createElement(_components.Spinner, null);
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, "Settings"), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: onSubmit,
      className: "mt-5"
    }, this.props.messages && this.props.messages.map(message => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `alert ${(0, _helpers.getAlertClassName)(message.type)}`,
        role: "alert",
        key: _uuid.default.v4()
      }, message.text);
    }), state.error && /*#__PURE__*/_react.default.createElement("div", {
      className: "alert alert-danger",
      role: "alert"
    }, state.error), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, this.renderFormGrid(fields)), fetching && /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-primary mt-4",
      disabled: true
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "spinner-border spinner-border-sm",
      role: "status",
      "aria-hidden": "true"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "Loading...")), !fetching && /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-primary mt-4"
    }, "Update")));
  }
}
var _default = exports.default = EditFormFactory;
module.exports = exports.default;